/**
 * useEltJobs Hook
 *
 * React Query hook for fetching ELT jobs list.
 */

import { useQuery } from '@tanstack/react-query';
import { eltJobService } from '../../../api/elt-job.service';
import type { EltJob, EltJobListQuery } from '../../../types/elt-job.types';

export const ELT_JOBS_QUERY_KEY = 'eltJobs';

export function useEltJobs(tenantId: string, query?: EltJobListQuery) {
  return useQuery<EltJob[], Error>({
    queryKey: [ELT_JOBS_QUERY_KEY, tenantId, query],
    queryFn: () => eltJobService.listEltJobs(tenantId, query),
    enabled: !!tenantId,
    staleTime: 30000,
  });
}
